<div class="smx-card smx-roster animated fadeIn" [ngClass]="{'margin-dialog' : dialog}">
  <div class="smx-header">
    <div class="smx-title">Lead Assignment Roster</div>
    <div class="smx-subtle">Start with weekly hours. Add exceptions only if needed.</div>
  </div>

  <!-- Weekly roster -->
  <section class="smx-section">
    <div class="smx-section-title">Weekly Hours</div>

    <div class="smx-week-grid smx-tight">
      @for (d of weekdays; track d) {
        <div class="smx-day">
          <div class="smx-day-head">
            <span class="smx-day-label">{{ weekLabel[d] }}</span>
            <mat-slide-toggle color="primary" [checked]="isDayOn(d)" (change)="toggleDayOff(d, $event.checked)">
              {{ isDayOn(d) ? 'Open' : 'Off' }}
            </mat-slide-toggle>
          </div>
          @if (isDayOn(d)) {
            <div class="smx-blocks">
              @for (b of daysFA(d).controls; track b; let i = $index) {
                <div class="smx-block" [formGroup]="b">
                  <mat-form-field appearance="outline" class="smx-input smx-w-120">
                    <mat-label>Start</mat-label>
                    <input matInput [matTimepicker]="weeklyStartPicker" formControlName="start" />
                    <mat-timepicker-toggle matSuffix [for]="weeklyStartPicker"></mat-timepicker-toggle>
                    <mat-timepicker #weeklyStartPicker></mat-timepicker>
                    @if (b.hasError('timeOrder')) {
                      <mat-error>Start must be before end</mat-error>
                    }
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="smx-input smx-w-120">
                    <mat-label>End</mat-label>
                    <input matInput [matTimepicker]="weeklyEndPicker" formControlName="end" />
                    <mat-timepicker-toggle matSuffix [for]="weeklyEndPicker"></mat-timepicker-toggle>
                    <mat-timepicker #weeklyEndPicker></mat-timepicker>
                  </mat-form-field>
                  <button mat-icon-button class="smx-icon-btn" aria-label="Remove block"
                    (click)="removeBlock(d, i)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              }
              <button mat-stroked-button class="smx-add-btn" type="button" (click)="addBlock(d)">
                <mat-icon>add</mat-icon>
                Add block
              </button>
            </div>
          }
        </div>
      }
    </div>
  </section>

  <!-- Progressive options -->
  <section class="smx-section smx-advanced">
    <div class="smx-advanced-head">
      <mat-slide-toggle [(ngModel)]="showAdvanced">Advanced rules</mat-slide-toggle>
    </div>

    @if (showAdvanced) {
      <div class="smx-advanced-body">
        <!-- Global date window -->
        <div class="smx-adv-row">
          <mat-slide-toggle (change)="onToggleRepeatWindow($event.checked)" [checked]="showRepeatWindow">
            Limit to a date window
          </mat-slide-toggle>
          @if (showRepeatWindow) {
            <div class="smx-window-inputs" [formGroup]="form.get('weeklyRoster')">
              <mat-form-field appearance="outline" class="smx-input smx-w-180">
                <mat-label>Effective from</mat-label>
                <input matInput [matDatepicker]="weeklyFromPicker" formControlName="effectiveFrom" />
                <mat-datepicker-toggle matSuffix [for]="weeklyFromPicker"></mat-datepicker-toggle>
                <mat-datepicker #weeklyFromPicker></mat-datepicker>
              </mat-form-field>
              <mat-form-field appearance="outline" class="smx-input smx-w-180">
                <mat-label>Repeat till</mat-label>
                <input matInput [matDatepicker]="weeklyTillPicker" formControlName="repeatTillDate" />
                <mat-datepicker-toggle matSuffix [for]="weeklyTillPicker"></mat-datepicker-toggle>
                <mat-datepicker #weeklyTillPicker></mat-datepicker>
              </mat-form-field>
            </div>
          }
        </div>
        <!-- Nth weekday rules -->
        <div class="smx-adv-row">
          <mat-slide-toggle [(ngModel)]="showNthWeekday">
            Nth weekday rules (e.g., 2nd & 4th Saturday)
          </mat-slide-toggle>
        </div>
        @if (showNthWeekday) {
          <div class="smx-rule-list">
            @for (r of dowRulesFA().controls; track r; let i = $index) {
              <div class="smx-rule" [formGroup]="r">
                <div class="smx-rule-line">
                  <mat-form-field appearance="outline" class="smx-input smx-w-140">
                    <mat-label>Type</mat-label>
                    <mat-select formControlName="type">
                      <mat-option value="exclude">Exclude</mat-option>
                      <mat-option value="include">Include</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="smx-input smx-w-140">
                    <mat-label>Weekday</mat-label>
                    <mat-select formControlName="weekday">
                      @for (w of weekdays; track w) {
                        <mat-option [value]="w">{{ weekLabel[w] }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="smx-input smx-w-220">
                    <mat-label>Weeks (1–5)</mat-label>
                    <mat-select formControlName="weeks" multiple>
                      @for (n of [1,2,3,4,5]; track n) {
                        <mat-option [value]="n">{{ n }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  <!-- group toggles side-by-side -->
                  <div class="smx-toggle-group">
                    <mat-slide-toggle formControlName="fullDay" class="smx-toggle">Full day</mat-slide-toggle>
                    <mat-slide-toggle class="smx-toggle" [checked]="r.get('useWindow')?.value"
                      (change)="onToggleDowWindow(i, $event.checked)">
                      Schedule this rule
                    </mat-slide-toggle>
                  </div>
                  <span class="smx-spacer"></span>
                  <button mat-icon-button class="smx-icon-btn" aria-label="Remove rule"
                    (click)="removeDowRule(i)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
                <!-- leave your inline date fields as-is -->
                @if (r.get('useWindow')?.value) {
                  <div class="smx-window-inputs smx-window-inline">
                    <mat-form-field appearance="outline" class="smx-input smx-w-180">
                      <mat-label>Effective from</mat-label>
                      <input matInput [matDatepicker]="dowFromPicker" formControlName="effectiveFrom" />
                      <mat-datepicker-toggle matSuffix [for]="dowFromPicker"></mat-datepicker-toggle>
                      <mat-datepicker #dowFromPicker></mat-datepicker>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="smx-input smx-w-180">
                      <mat-label>Repeat till</mat-label>
                      <input matInput [matDatepicker]="dowTillPicker" formControlName="repeatTillDate" />
                      <mat-datepicker-toggle matSuffix [for]="dowTillPicker"></mat-datepicker-toggle>
                      <mat-datepicker #dowTillPicker></mat-datepicker>
                    </mat-form-field>
                  </div>
                }
                <!-- Partial time windows -->
                @if (!r.get('fullDay')?.value) {
                  <div class="smx-blocks">
                    <div formArrayName="blocks">
                      @for (_ of getDowBlocks(i).controls; track _; let j = $index) {
                        <div class="smx-block"
                          [formGroupName]="j">
                          <mat-form-field appearance="outline" class="smx-input smx-w-120">
                            <mat-label>Start</mat-label>
                            <input matInput [matTimepicker]="dowStartPicker" formControlName="start" />
                            <mat-timepicker-toggle matSuffix [for]="dowStartPicker"></mat-timepicker-toggle>
                            <mat-timepicker #dowStartPicker></mat-timepicker>
                          </mat-form-field>
                          <mat-form-field appearance="outline" class="smx-input smx-w-120">
                            <mat-label>End</mat-label>
                            <input matInput [matTimepicker]="dowEndPicker" formControlName="end" />
                            <mat-timepicker-toggle matSuffix [for]="dowEndPicker"></mat-timepicker-toggle>
                            <mat-timepicker #dowEndPicker></mat-timepicker>
                          </mat-form-field>
                          <button mat-icon-button class="smx-icon-btn" aria-label="Remove block"
                            (click)="removeDowBlock(i, j)">
                            <mat-icon>delete</mat-icon>
                          </button>
                        </div>
                      }
                    </div>
                    <button mat-stroked-button class="smx-add-btn" type="button" (click)="addDowBlock(i)">
                      <mat-icon>add</mat-icon>
                      Add time window
                    </button>
                  </div>
                }
              </div>
            }
            <button mat-stroked-button class="smx-add-rule" type="button" (click)="addDowRule()">
              <mat-icon>add</mat-icon>
              Add nth weekday rule
            </button>
          </div>
        }
        <!-- Day-of-month rules -->
        <div class="smx-adv-row">
          <mat-slide-toggle [(ngModel)]="showDayOfMonth">
            Day-of-month rules (e.g., 1st & 15th off)
          </mat-slide-toggle>
        </div>
        @if (showDayOfMonth) {
          <div class="smx-rule-list">
            @for (r of domRulesFA().controls; track r; let i = $index) {
              <div class="smx-rule" [formGroup]="r">
                <div class="smx-rule-line">
                  <mat-form-field appearance="outline" class="smx-input smx-w-140">
                    <mat-label>Type</mat-label>
                    <mat-select formControlName="type">
                      <mat-option value="exclude">Exclude</mat-option>
                      <mat-option value="include">Include</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="smx-input smx-w-280">
                    <mat-label>Dates (1–31)</mat-label>
                    <mat-select formControlName="dates" multiple>
                      @for (n of [].constructor(31); track $index; let idx = $index) {
                        <mat-option [value]="idx+1">{{
                        idx+1 }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  <div class="smx-toggle-group">
                    <mat-slide-toggle formControlName="fullDay" class="smx-toggle">Full day</mat-slide-toggle>
                    <mat-slide-toggle class="smx-toggle" [checked]="r.get('useWindow')?.value"
                      (change)="onToggleDomWindow(i, $event.checked)">
                      Schedule this rule
                    </mat-slide-toggle>
                  </div>
                  <span class="smx-spacer"></span>
                  <button mat-icon-button class="smx-icon-btn" aria-label="Remove rule"
                    (click)="removeDomRule(i)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
                @if (r.get('useWindow')?.value) {
                  <div class="smx-window-inputs smx-window-inline">
                    <mat-form-field appearance="outline" class="smx-input smx-w-180">
                      <mat-label>Effective from</mat-label>
                      <input matInput [matDatepicker]="datepicker" formControlName="effectiveFrom" />
                      <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
                      <mat-datepicker #datepicker></mat-datepicker>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="smx-input smx-w-180">
                      <mat-label>Repeat till</mat-label>
                      <input matInput [matDatepicker]="domTillPicker" formControlName="repeatTillDate" />
                      <mat-datepicker-toggle matSuffix [for]="domTillPicker"></mat-datepicker-toggle>
                      <mat-datepicker #domTillPicker></mat-datepicker>
                    </mat-form-field>
                  </div>
                }
                @if (!r.get('fullDay')?.value) {
                  <div class="smx-blocks">
                    <div formArrayName="blocks">
                      @for (_ of getDomBlocks(i).controls; track _; let j = $index) {
                        <div class="smx-block"
                          [formGroupName]="j">
                          <mat-form-field appearance="outline" class="smx-input smx-w-120">
                            <mat-label>Start</mat-label>
                            <input matInput [matTimepicker]="domStartPicker" formControlName="start" />
                            <mat-timepicker-toggle matSuffix [for]="domStartPicker"></mat-timepicker-toggle>
                            <mat-timepicker #domStartPicker></mat-timepicker>
                          </mat-form-field>
                          <mat-form-field appearance="outline" class="smx-input smx-w-120">
                            <mat-label>End</mat-label>
                            <input matInput [matTimepicker]="domEndPicker" formControlName="end" />
                            <mat-timepicker-toggle matSuffix [for]="domEndPicker"></mat-timepicker-toggle>
                            <mat-timepicker #domEndPicker></mat-timepicker>
                          </mat-form-field>
                          <button mat-icon-button class="smx-icon-btn" aria-label="Remove block"
                            (click)="removeDomBlock(i, j)">
                            <mat-icon>delete</mat-icon>
                          </button>
                        </div>
                      }
                    </div>
                    <button mat-stroked-button class="smx-add-btn" type="button" (click)="addDomBlock(i)">
                      <mat-icon>add</mat-icon>
                      Add time window
                    </button>
                  </div>
                }
              </div>
            }
            <button mat-stroked-button class="smx-add-rule" type="button" (click)="addDomRule()">
              <mat-icon>add</mat-icon>
              Add day-of-month rule
            </button>
          </div>
        }
      </div>
    }
  </section>

  <!-- Footer -->
  <div class="smx-footer">
    <div class="smx-muted">All times are in {{ form.get('tz')?.value }}.</div>
    <span class="smx-spacer"></span>
    <button mat-flat-button color="primary" (click)="onSaveClick()">Save</button>
  </div>
</div>
